<template>
  <div class="d2-container-full">
    <!-- <el-scrollbar> -->
    <div
      v-if="$slots.header"
      class="d2-container-full__header"
      ref="header"
      :class="this.active?'active':'close'">
      <slot name="header" />
      <d2-header-switch />
    </div>
    <div
      class="d2-container-full__body"
      ref="body">
      <slot />
    </div>
    <div
      v-if="$slots.footer"
      class="d2-container-full__footer"
      ref="footer">
      <slot name="footer" />
    </div>
    <!-- </el-scrollbar> -->
  </div>
</template>

<script>
import scroll from './mixins/normal'
export default {
  name: 'D2ContainerFull',
  mixins: [scroll],
  components: {
    d2HeaderSwitch: () => import('./d2-header-switch.vue')
  },
  data() {
    return {
      oHeaderStyle: {
        padding: '20px 20px 0 20px'
      }
    }
  },
  computed: {
    active() {
      return this.$store.state.d2admin.tsearch.active
    }
  },
  mounted() {
    // 增加滚动事件监听
    this.addScrollListener()
  },
  beforeDestroy() {
    // 移除滚动事件监听
    this.removeScrollListener()
  }
}
</script>

<style lang="scss">
.d2-container-full {
  .d2-container-full__header {
    position: relative;
    transition: all 0.2s ease;
    &.close {
      height: 0;
      padding: 0 20px !important;
      form {
        opacity: 0;
      }
      border-bottom-color: rgba(0, 0, 0, 0) !important;
    }
    .el-form-item {
      margin-bottom: 4px;
    }
  }
}

//滚动条的宽度
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
//滚动条的滑块
::-webkit-scrollbar-thumb {
  background-color: #a1a3a9;
  border-radius: 3px;
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/d2-container/components/d2-container-full.vue"
}
</vue-filename-injector>
